const fields = [
  {
    dataIndex: 'name',
    key: 'name',
    title: '服务内容',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'statusStr',
    key: 'statusStr',
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '创建时间'
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 140,
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 10,
    label: '名称',
    component: 'AInput',
    placeholder: '请输入名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 8,
    label: '创建日期',
    component: 'ASelect',
    prop: 'searchValue',
    placeholder: '选择创建日期',
    list: [
      { label: '全部时间', value: 0 },
      { label: '一个月', value: 1 },
      { label: '三个月', value: 2 },
      { label: '半年', value: 3 },
      { label: '一年', value: 4 }
    ]
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [
      { name: '编辑', cb: 'edit' },
      { name: '删除', cb: 'delete', divider: true }
    ]
  }
]

module.exports = {
  fields,
  formRow,
  slotOpt
}
